export * from './bed-availability.service';